import { render, staticRenderFns } from "./pbsign.vue?vue&type=template&id=20bac254&scoped=true&"
import script from "./pbsign.vue?vue&type=script&lang=js&"
export * from "./pbsign.vue?vue&type=script&lang=js&"
import style0 from "./pbsign.vue?vue&type=style&index=0&id=20bac254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bac254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bac254')) {
      api.createRecord('20bac254', component.options)
    } else {
      api.reload('20bac254', component.options)
    }
    module.hot.accept("./pbsign.vue?vue&type=template&id=20bac254&scoped=true&", function () {
      api.rerender('20bac254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/pbsign.vue"
export default component.exports